module.exports = __webpack_public_path__ + "static/foodbox@2x-819736dd9b9ea2b58c80c0a4a8a45a90.png";